export enum CafsType {
  "Tree" = "Tree",
  "Crop" = "Crop",
  "Input" = "Input",
}
